import { SimpleAlert } from '@cimplico/components';
import { SubscriptionStatus } from '../../types/firm';
import { useFirmContext } from '../../providers/FirmProvider';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';

function SubscriptionBanner(): JSX.Element {
    const { shortId, subscription, name } = useFirmContext();
    const { isAdmin } = useIsFirmRole();
    const pluralFirm = name.toLowerCase().endsWith('s') ? `${name}'` : `${name}'s`;

    return (
        <>
            {subscription?.status === SubscriptionStatus.PAUSED && (
                <SimpleAlert
                    title={`${pluralFirm} subscription is currently PAUSED, ${
                        isAdmin
                            ? 'resume it to continue using Cimplico Workpapers'
                            : 'get your firm administrator to resume it to continue using Cimplico Workpapers'
                    }.`}
                    type="warn"
                    actionText={isAdmin ? { text: 'Resume now', href: `/${shortId}/settings` } : undefined}
                />
            )}
            {subscription?.status === SubscriptionStatus.PAST_DUE && (
                <SimpleAlert
                    title={`${pluralFirm} subscription is currently UNPAID, ${
                        isAdmin
                            ? 'please pay the outstanding amount to continue using Cimplico Workpapers'
                            : 'get your firm administrator to pay the outstanding amount to continue using Cimplico Workpapers'
                    }.`}
                    type="warn"
                    actionText={isAdmin ? { text: 'Pay now', href: `/${shortId}/settings` } : undefined}
                />
            )}
            {subscription?.status === SubscriptionStatus.CANCELED && (
                <SimpleAlert
                    title={`${pluralFirm} subscription is currently CANCELLED. ${
                        isAdmin
                            ? 'Please contact support to restart your subscription'
                            : 'Please ask your firm administrator to contact support'
                    }.`}
                    type="error"
                    link={isAdmin ? { text: 'Contact Support', to: `https://support.cimplico.com` } : undefined}
                />
            )}
        </>
    );
}

export default SubscriptionBanner;
